import React from "react";
import {
  daysUntil,
  formatSpanishDate,
  hasEnded,
} from "../../../utils/dateUtils";

// Bloque de "status", no una tarjeta: solo divisores sutiles arriba/abajo,
// para que no compita visualmente con las tarjetas de categorías. La fecha
// límite va primero (ancla), los días restantes van después (refuerzo).
const CountdownStatus = ({ endTime }) => {
  const ended = hasEnded(endTime);
  const days = daysUntil(endTime);
  const deadline = formatSpanishDate(endTime);

  return (
    <div className="py-2 border-violet-300/40">
      <p className="text-xs font-semibold text-brand-muted">
        {ended ? (
          "🚫 Las votaciones han finalizado."
        ) : (
          <>Puedes votar hasta el <span className="underline">{deadline}</span></>
        )}
      </p>
      <p className="text-xs text-gray-500 mt-0.5">
        {ended
          ? `Cerraron el ${deadline}.`
          : days <= 0
          ? "⏳ ¡Hoy es el último día para votar!"
          : `⏳ Quedan ${days} día${days === 1 ? "" : "s"} para votar`}
      </p>
    </div>
  );
};

export default CountdownStatus;
